import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="py-10 sm:py-12 px-4 bg-white" data-id="element-101">
      <div className="max-w-xl mx-auto" data-id="element-102">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-brand-surface border border-brand-border p-6 sm:p-8 rounded-2xl text-center relative overflow-hidden shadow-sm" data-id="element-103">
          <ShieldCheckIcon className="w-14 h-14 text-brand-navy mx-auto mb-4 relative z-10" data-id="element-104" />

          <h3 className="text-xl sm:text-2xl font-black text-brand-navy mb-3 relative z-10 uppercase" data-id="element-105">
            VERBESSERE DEINEN UNTERRICHT ODER WIR ERSTATTEN DIR JEDEN RAPPEN
          </h3>

          <p className="text-brand-text text-sm sm:text-base font-medium leading-relaxed relative z-10" data-id="element-106">
            7 Tage Zeit das System auszuprobieren. Wenn du nicht spürst dass
            dein Unterricht professioneller und wertvoller geworden ist
            erstatten wir dir jeden Franken zurück. Ohne Fragen.
          </p>
        </motion.div>
      </div>
    </section>;
}